/**
 * @fileoverview Redux slice for list state management
 * @see {@link src/store/newLists/newLists.selectors.ts} - State selectors
 */

import { createSlice } from "@reduxjs/toolkit";

/** Type for a list item */
interface ListItem {
  id: string;
  title: string;
}

/** Type for list parameters */
interface ListParams {
  limit: number;
  page: number;
  total: number;
}

/** Type for the lists state */
interface NewListsState {
  allLists: ListItem[];
  currentNewList: ListItem;
  listParams: ListParams;
}

/** Initial state for lists */
const initialState: NewListsState = {
  allLists: [],
  currentNewList: { id: "all companies", title: "All Companies" },
  listParams: { limit: 25, page: 1, total: 0 },
};

const newListsSlice = createSlice({
  name: "newLists",
  initialState,
  reducers: {
    /** Set all available lists */
    setAllLists: (state, { payload }) => {
      state.allLists = payload;
    },
    /** Set currently active list */
    setCurrentNewList: (state, { payload }) => {
      state.currentNewList = payload;
    },
    /** Update list parameters */
    setListParams: (state, { payload }) => {
      state.listParams = {
        ...state.listParams,
        ...payload,
      };
    },
  },
});

export const newListActions = newListsSlice.actions;
export default newListsSlice;
